/// <reference path="../../../../../rcwebmodels/TripDetails.cs.d.ts" />
import * as React from 'react';
import $ from 'jquery';
import moment from 'moment';
import { RCUtils } from './../../RCUtils';
import forEach from 'lodash/forEach';
import { PopupWindow } from '../sharedcomponents/PopupWindow';
//import { DateTime } from 'react-datetime-bootstrap';
import DatePicker from 'react-datepicker';
import DateFormat from 'dateformat';

var Config: any = require('../../Config.json');

interface CreateTripSettingsState {
    SelectedReefers: any[];
    TripGeofencesDetails: server.TripGeofencesDetails;
    refTripDefinition: server.RefTripDefinition[];
    tripGeofencesByTrip: server.TripGeofencesByTrip[];
    DepartureChecked: boolean;
    ArrivalChecked: boolean;
    IsCommandIssued: boolean;
    PrevSelectedItems: any[];
}

var newTripGeofencesDetails: server.TripGeofencesDetails = {
    reeferID: null, TripDefinitionSelectedValue: '-1', unitMasetrId: null, OriginGeofence: '', DestinationGeofence: '', TripName: null,
    SFrmDate: DateFormat(new Date(moment(new Date(DateFormat(new Date(Date.now()), 'mm/dd/yyyy'))).startOf('day').toString()), 'mm/dd/yyyy HH:MM:ss'),
    SToDate: DateFormat(new Date(moment(new Date(DateFormat(new Date(Date.now()), 'mm/dd/yyyy'))).endOf('day').toString()), 'mm/dd/yyyy HH:MM:ss'), CommandUnits: []
};

export class CreateTrip extends React.Component<any, CreateTripSettingsState> {
    myRequest: any;
    constructor(props: any) {
        super(props);
        this.state = { SelectedReefers: [], TripGeofencesDetails: newTripGeofencesDetails, refTripDefinition: [], tripGeofencesByTrip: [], DepartureChecked: false, ArrivalChecked: false, IsCommandIssued: false, PrevSelectedItems: []};
        $('#globalLoader').show();
        var request = RCUtils.FetchRequest(Config.ApiBaseUrl + '/api/Trip/RefTripDefinitionLst')
        RCUtils.fetchFaultRetry(request)
            .then(RCUtils.handleResponse)
            .then(response => response.json() as Promise<server.RefTripDefinition[]>)
            .then(data => {
                this.setState({ refTripDefinition: data });
                $('#globalLoader').hide();
            });
    }

    DepartureCheckedtoggleChange = () => {
        this.setState({
            DepartureChecked: !this.state.DepartureChecked,
        });
    }

    ArrivalCheckedtoggleChange = () => {
        this.setState({
            ArrivalChecked: !this.state.ArrivalChecked,
        });
    }

    public handleOnChange(event: any): void {
        const name = event.target.name;
        const value = event.target.value;
        //this.setState({ [name]: value });
    }

    TripNameOnChange(event: any): void {
        var Value: string = event.currentTarget.value;
        var tripGeofencesDetails: server.TripGeofencesDetails = JSON.parse(JSON.stringify(this.state.TripGeofencesDetails));
        tripGeofencesDetails.TripName = Value;
        this.setState({ TripGeofencesDetails: tripGeofencesDetails });
    }

    toDateOnChange(date) {
        var tripGeofencesDetails: server.TripGeofencesDetails = JSON.parse(JSON.stringify(this.state.TripGeofencesDetails));
        tripGeofencesDetails.SToDate = DateFormat(new Date(date), 'mm/dd/yyyy HH:MM');
        this.setState({ TripGeofencesDetails: tripGeofencesDetails });
    }

    fromDateOnChange(date) {
        var tripGeofencesDetails: server.TripGeofencesDetails = JSON.parse(JSON.stringify(this.state.TripGeofencesDetails));
        tripGeofencesDetails.SFrmDate = DateFormat(new Date(date), 'mm/dd/yyyy HH:MM');
        this.setState({ TripGeofencesDetails: tripGeofencesDetails });
    }

    handleSubmit() {
        var tripGeofencesDetails: server.TripGeofencesDetails = JSON.parse(JSON.stringify(this.state.TripGeofencesDetails));
        var fCommends = this.setForwardCommandUnits();
        tripGeofencesDetails.unitMasetrId = this.state.SelectedReefers[0].UnitMasterID;
        tripGeofencesDetails.CommandUnits = fCommends;
        if (!this.state.ArrivalChecked) {
            tripGeofencesDetails.SToDate = null;
        }
        if (!this.state.DepartureChecked) {
            tripGeofencesDetails.SFrmDate = null;
        }
        if (this.state.ArrivalChecked && this.state.DepartureChecked) {
            if ((moment(new Date(tripGeofencesDetails.SFrmDate)) == moment(new Date(tripGeofencesDetails.SToDate))) || (moment(new Date(tripGeofencesDetails.SFrmDate)) > moment(new Date(tripGeofencesDetails.SToDate)))) {
                PopupWindow.showErrorMessage("Create Trip", "Arrival date/time must be later than Earliest Departure date/time.");
                return;
            }
        }
        if ((this.state.TripGeofencesDetails != null && this.state.TripGeofencesDetails.TripName == null)) {
            PopupWindow.showErrorMessage("Create Trip", "Please enter valid Trip Name.");
            return;
        }
        else if ((this.state.TripGeofencesDetails.TripName != null && this.state.TripGeofencesDetails.TripName.trim() == "")) {
            PopupWindow.showErrorMessage("Create Trip", "Please enter valid Trip Name.");
            return;
        }
        else if ((this.state.TripGeofencesDetails != null && this.state.TripGeofencesDetails.TripDefinitionSelectedValue == "-1")) {
            PopupWindow.showErrorMessage("Create Trip", "Please select Trip Definition.");
            return;
        }
        else if ((this.state.TripGeofencesDetails != null && this.state.TripGeofencesDetails.DestinationGeofence.trim() == "") && (!this.state.ArrivalChecked || !this.state.DepartureChecked)) {
            PopupWindow.showErrorMessage("Create Trip", "A trip should have either Origin and Destination Geofence or Earliest Departure and Arrival or Both.");
            return;
        }
        else if ((this.state.TripGeofencesDetails != null && this.state.TripGeofencesDetails.OriginGeofence.trim() == "") && (!this.state.ArrivalChecked || !this.state.DepartureChecked)) {
            PopupWindow.showErrorMessage("Create Trip", "A trip should have either Origin and Destination Geofence or Earliest Departure and Arrival or Both.");
            return;
        }
        else {
            $('#globalLoader').show();
            var url = Config.ApiBaseUrl + '/api/Trip/SaveTripDefDetails';
            var request = RCUtils.FetchRequest(url, { method: 'POST', body: JSON.stringify(tripGeofencesDetails), headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' } });
            fetch(request)
                .then(RCUtils.handleError)
                .then(response => response.json())
                .then(data => {
                    $('#globalLoader').hide();
                    PopupWindow.showErrorMessage("Create Trip", data);
                    if (data == "Trip created successfully.") {
                        this.setState({ TripGeofencesDetails: newTripGeofencesDetails, IsCommandIssued: true, PrevSelectedItems: this.props.reeferData }, () => { this.props.IsCommandIssued(this.state.IsCommandIssued); this.props.PrevSelectedItems(this.props.reeferData) });
                        $('#contextMenuModel .btn-close').click();
                        this.closePopUp();
                        this.props.refreshStatusGrid();
                        //this.setState({ TripGeofencesDetails: newTripGeofencesDetails });
                        
                    }

                });
            // $('#CreateTrip').hide();
            //this.setState({ TripGeofencesDetails: newTripGeofencesDetails });            
        }
    }

    setForwardCommandUnits() {
        var userId = 0;
        var commandUnits = [];
        if (this.state.SelectedReefers.length > 0) {
            forEach(this.state.SelectedReefers, function (value, key) {
                var commandUnitObject = {
                    "RcdEventID": value.RCDEventID,
                    "RCDMasterID": value.RCDMasterID,
                    "RcdId": value.RCDID,
                    "ReeferID": value.ReeferID,
                    "UnitControlEventID": value.UnitControlEventID,
                    "UnitEventID": value.UnitEventID,
                    "UnitMasterID": value.UnitMasterID,
                    "ParentEventId": (value.ParentEventID.HasValue) ? value.ParentEventID.Value : 0,
                    "UserId": userId,
                    "TripId": value.TripId
                };

                commandUnits.push(commandUnitObject);
            });
        }
        else {
            alert('Please select at least one record to proceed.');
        }

        return commandUnits;
    }

    componentDidMount() {
        var reeferData = this.props.reeferData;
        if (reeferData != undefined && reeferData != null && reeferData.length > 0) {
            var tripGeofencesDetails: server.TripGeofencesDetails = JSON.parse(JSON.stringify(this.state.TripGeofencesDetails));
            if (reeferData[0].ReeferID != null && reeferData[0].ReeferID != "") {
                tripGeofencesDetails.reeferID = reeferData[0].ReeferID;
                this.setState({ SelectedReefers: reeferData, TripGeofencesDetails: tripGeofencesDetails, ArrivalChecked: false, DepartureChecked: false });//WI-21781 QA - IE - Route Deviation - Issues with Trip Creation
            }
        }
    }

    componentWillReceiveProps(nextprops: any) {
        var tripGeofencedtls = this.state.TripGeofencesDetails;
        tripGeofencedtls.TripDefinitionSelectedValue = "-1";
        tripGeofencedtls.OriginGeofence = '';
        tripGeofencedtls.DestinationGeofence = '';
        tripGeofencedtls.TripName = null;
        tripGeofencedtls.TripName = "";
        this.setState({ TripGeofencesDetails: tripGeofencedtls, ArrivalChecked: false, DepartureChecked: false });//WI-21781 QA - IE - Route Deviation - Issues with Trip Creation
        var reeferData = nextprops.reeferData;
        if (reeferData != undefined && reeferData != null && reeferData.length > 0) {
            var tripGeofencesDetails: server.TripGeofencesDetails = JSON.parse(JSON.stringify(this.state.TripGeofencesDetails));
            if (reeferData[0].ReeferID != null && reeferData[0].ReeferID != "") {
                tripGeofencesDetails.reeferID = reeferData[0].ReeferID;
                this.setState({ SelectedReefers: reeferData, TripGeofencesDetails: tripGeofencesDetails });
            }
        }
    }

    GetTripDefination(value: any) {
        $('#globalLoader').show();
        var request = RCUtils.FetchRequest(Config.ApiBaseUrl + '/api/Trip/GetGeofencesByTripId', { method: 'POST', body: value, headers: { 'Accept': 'applicatio/json', 'Content-Type': 'application/json' } })
        RCUtils.fetchFaultRetry(request)
            .then(RCUtils.handleResponse)
            .then(response => response.json() as Promise<server.TripGeofencesByTrip[]>)
            .then(data => {
                this.setState({ tripGeofencesByTrip: data });
                var tripGeofencesDetails: server.TripGeofencesDetails = JSON.parse(JSON.stringify(this.state.TripGeofencesDetails));
                tripGeofencesDetails.OriginGeofence = this.state.tripGeofencesByTrip[0].SourceGofenceAddress;
                tripGeofencesDetails.DestinationGeofence = this.state.tripGeofencesByTrip[0].DestGofenceAddress;
                tripGeofencesDetails.TripDefinitionSelectedValue = value;
                this.setState({ TripGeofencesDetails: tripGeofencesDetails });
                $('#globalLoader').hide();
            });
    }

    public handleOnChangeDropDown(event: any): void {
        //this.setState({ [event.target.name]: event.target.value })
        this.GetTripDefination(event.target.value);
    }

    closePopUp() {
        //document.getElementById("hidePopUpBtn").click();
        $("#hidePopUpBtn .btn-close").click();
    }

    public render() {
        return (
            <div>
                {this.LoadTripDetailsData(this.state.refTripDefinition)}
            </div>
        );
    }

    LoadTripDetailsData(data: any) {
        const Arrivalhidden = this.state.ArrivalChecked ? '' : 'hidden';
        const Departurehidden = this.state.DepartureChecked ? '' : 'hidden';
        var tripDefinitions = this.state.refTripDefinition;
        var TripDefinationOptions = tripDefinitions.map(function (trip) {
            return (
                <option key={trip.TripDefId} value={trip.TripDefId}>{trip.TripDefNm}</option>
            );
        });
        return (<div>
            <div className="row mt-6">
                <div className="col-md-5 text-sm-end pe-0 ">
                    <span className='col-form-label'> Reefer ID :</span>
                </div>
                <div className="col-md-5">
                    <span>
                        {(this.state.TripGeofencesDetails != undefined) ? this.state.TripGeofencesDetails.reeferID : ''}
                    </span>
                </div>
            </div>
            <div className="row mt-6">
                <div className="col-md-5 text-sm-end pe-0 ">
                    <label className='col-form-label'> Trip Definition :</label>
                </div>
                <div className="col-md-5">
                    <select className="form-select" id="cBoxSeverityStates" name="TripDefinationSelectedValue" value={this.state.TripGeofencesDetails.TripDefinitionSelectedValue}
                        onChange={e => this.handleOnChangeDropDown(e)} >
                        <option value="-1">Select Trip Definition...</option>
                        {TripDefinationOptions}
                    </select>
                </div>
            </div>
            <div className="row mt-6">
                <div className="col-md-5 text-sm-end pe-0 ">
                    <span className='col-form-label'> Origin Geofence :</span>
                </div>
                <div className="col-md-5">
                    <span>{this.state.TripGeofencesDetails.OriginGeofence} </span>
                </div>
            </div>
            <div className="row mt-6">
                <div className="col-md-5 text-sm-end pe-0 ">
                    <span className='col-form-label'> Destination Geofence :</span>
                </div>
                <div className="col-md-5">
                    <span>  {this.state.TripGeofencesDetails.DestinationGeofence} </span>
                </div>
            </div>
            <div className="row mt-6">
                <div className="col-md-5 text-sm-end pe-0 ">
                    <label className='col-form-label'>Trip Name :</label>
                </div>
                <div className="col-md-5">
                    <input type="text" className="form-control" id="tripName" name="TripName" onChange={e => this.TripNameOnChange(e)} value={this.state.TripGeofencesDetails.TripName}/>
                </div>
            </div>
            <div className="row mt-6">
                <div className="col-md-5 text-sm-end pe-0 ">
                    <div className='trip-label'> <input type="checkbox" className='departure-checkbox' name="EarliestDep" checked={this.state.DepartureChecked} onChange={this.DepartureCheckedtoggleChange} />Earliest Departure : </div>
                </div>
                <div className="col-md-5">
                    <div id="dcalc" className={Departurehidden}>
                        <div className="col-md-12">
                            <div id='datetimepickerF'>
                                <DatePicker
                                    selected={new Date(this.state.TripGeofencesDetails.SFrmDate)}
                                    onChange={this.fromDateOnChange.bind(this)}
                                    timeInputLabel="Time:"
                                    showYearDropdown
                                    yearDropdownItemNumber={5}
                                    dateFormat="MM/dd/yyyy hh:mm aa"
                                    showTimeInput
                                    className=""
                                    id="fDate"
                                />

                            </div>
                        </div>
                    </div>
                </div>
                
            </div>
            <div className="row mt-6 mb-3">
                <div className="col-md-5 text-sm-end pe-0 ">

                    <div className='trip-label'> <input type="checkbox" className='departure-arriaval' name="Arrival" checked={this.state.ArrivalChecked} onChange={this.ArrivalCheckedtoggleChange} /> Arrival : </div>
                </div>

                <div className="col-md-5">
                    <div className={Arrivalhidden}>
                        <div className="col-md-12">
                            <div id='datetimepickerT'>
                                <DatePicker
                                    selected={new Date(this.state.TripGeofencesDetails.SToDate)}
                                    onChange={this.toDateOnChange.bind(this)}
                                    timeInputLabel="Time:"
                                    showYearDropdown
                                    yearDropdownItemNumber={5}
                                    dateFormat="MM/dd/yyyy hh:mm aa"
                                    showTimeInput
                                    className=""
                                    id="tDate"
                                />
                            </div>
                        </div>
                    </div>
                </div>


                
            </div>
            <div className="modal-footer">
                <button type="button" id="hidePopUpBtn" className="btn btn-secondary" data-bs-dismiss="modal">Cancel</button>
                <button type="button" className="btn btn-primary" onClick={this.handleSubmit.bind(this)}>Save</button>
                
            </div>
        </div>)
    }
}